<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Punto de Venta</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-text-field label="* Nombre Punto Venta" v-model.trim="pventa.nombre" dense outlined></v-text-field>
            <v-text-field label="* Descripcion" v-model.trim="pventa.descripcion" dense outlined></v-text-field>

            <v-select
              label="* Codigo Tipo Punto Venta"
              v-model="pventa.tipo_punto_venta"
              :items="tipos"
              item-value="codigo"
              dense
              outlined
            ></v-select>
            <v-text-field
              label="* Descripcion tipo"
              v-model.trim="pventa.tipo_punto_venta_descripcion"
              dense
              outlined
            ></v-text-field>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ pventa.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        tipos: [],
        pventa: {
          id: null,
          nombre: 'test go postman',
          descripcion: 'mandando a go y luego factu',
          tipo_punto_venta: null,
          sucursal_id: null,
          codigo_sucursal: null,
          nit: '4265269017',
          tipo_punto_venta_descripcion: '',
        },
      };
    },
    components: {},
    watch: {
      'pventa.tipo_punto_venta': function() {
        if (this.pventa.tipo_punto_venta) {
          let t = this.tipos.find((x) => x.codigo == this.pventa.tipo_punto_venta);
          if (t) this.pventa.tipo_punto_venta_descripcion = t.descripcion;
        }
      },
    },
    methods: {
      openmodal(item, sucursalId, numero_sucursal, xsucursal) {
        this.msg = '';
        this.dialog = true;
        this.getcodigotipo();
        this.pventa.id = null;
        this.pventa.sucursal_id = parseInt(sucursalId);
        this.pventa.codigo_sucursal = parseInt(numero_sucursal);
        this.pventa.tipo_punto_venta = null;
        this.pventa.descripcion = '';
        this.pventa.nombre = '';
        this.pventa.tipo_punto_venta_descripcion = '';
        if (xsucursal && xsucursal.nit) {
          this.pventa.nit = xsucursal.nit;
        }
        if (item) {
          this.pventa.id = item.id;
          this.pventa.sucursal_id = item.sucursal_id;
          this.pventa.codigo_sucursal = item.codigo_sucursal;
          this.pventa.tipo_punto_venta = item.tipo_punto_venta;
          this.pventa.descripcion = item.descripcion;
          this.pventa.nombre = item.nombre;
          this.pventa.tipo_punto_venta_descripcion = item.tipo_punto_venta_descripcion;
          //this.pventa.nit = item.nit;
        }
      },
      getcodigotipo() {
        let vue = this;
        this.tipos = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/puntoventa`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.map((x) => {
              x.codigo = parseInt(x.codigo);
              x.text = `${x.descripcion} (${x.codigo})`;
            });
            vue.tipos = data;
            //window.console.log('getcodigotipo:', data);
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      save() {
        this.msg = '';
        if (!this.pventa.sucursal_id) this.msg = 'No hay sucursal asignado.';
        if (!this.pventa.tipo_punto_venta) this.msg = 'Seleccione un tipo de punto de venta.';
        if (!this.pventa.descripcion) this.msg = 'Ingrese una descripcion';
        if (!this.pventa.nombre) this.msg = 'Ingrese un nombre de punto de venta';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.pventa.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
          data: this.pventa,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('pventanew::', data);
            if (data) {
              vue.msg = `${data.data}`;
              vue.$emit('newregpunto', data);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response);
            vue.loading = false;
          });
      },
    },
  };
</script>
